// src/utils/forms/multiLangHelper.js

/**
 * ✅ Handle multi-language field change (Simple - No auto-sync)
 * المستخدم يملأ ما يريده، الحقول الأخرى تبقى فارغة
 * الملأ التلقائي سيتم في مرحلة الإرسال فقط (payload builder)
 * 
 * @param {Function} setFormData - دالة تحديث الـ state
 * @param {Object} formData - البيانات الحالية
 * @param {String} field - اسم الحقل
 * @param {String} lang - اللغة (ar أو en)
 * @param {String} value - القيمة الجديدة
 */
export const handleMultiLangChange = (setFormData, formData, field, lang, value) => {
    setFormData(prev => {
        const currentValue = prev[field] || { ar: '', en: '' };

        return {
            ...prev,
            [field]: {
                ...currentValue,
                [lang]: value,
            },
        };
    });
};

/**
 * ✅ Force sync both languages (for fields that always need the same value)
 */
export const handleMultiLangChangeSync = (setFormData, formData, field, lang, value) => {
    setFormData(prev => ({
        ...prev,
        [field]: {
            ar: value,
            en: value
        }
    }));
};

/**
 * ✅ Parse multi-language field from API response
 */
export const parseMultiLang = (field) => {
    if (!field) return { ar: '', en: '' };
    if (typeof field === 'string') return { ar: field, en: field };
    return {
        ar: field.ar || '',
        en: field.en || '',
    };
};

/**
 * ✅ Initialize multi-language field
 */
export const initMultiLangField = () => ({
    ar: '',
    en: ''
});

/**
 * ✅ Check if multi-language field is empty
 */
export const isMultiLangEmpty = (field) => {
    if (!field) return true;
    return (!field.ar || field.ar.trim() === '') && (!field.en || field.en.trim() === '');
};

/**
 * ✅ Get multi-language value based on current language
 */
export const getMultiLangValue = (field, lang = 'ar') => {
    if (!field) return '';
    if (typeof field === 'string') return field;
    return field[lang] || field.ar || field.en || '';
};

/**
 * ✅ Check if both languages have same value
 */
export const isSyncedMultiLang = (field) => {
    if (!field) return true;
    return field.ar === field.en;
};
